<template>
  <div class="modal-overflow" style="max-height: 600px;">
    <div class="row">
      <div class="col-md-12">
        <el-input
          type="textarea"
          :rows="20"
          v-model="taskTemplateJson" />
      </div>
    </div>
    <div v-if="hasValidationErrors" style="margin-top: 12px;">
      <h6>Schema Validation Errors</h6>
      <ul>
        <li v-for="error in validationErrors">{{ maybeFilterProperty(error.property) }}: {{ error.message }}</li>
      </ul>
    </div>
    <div class="row" style="margin-top: 12px;">
      <div class="col-md-12">
        <button type="submit" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import {notifyError, notifyWarning, notifySuccess} from 'src/utilities/utils'
import {validate} from 'jsonschema'
import {CREATED, OK} from 'http-status-codes'
import {ptracGet, ptracPost, ptracPut} from '@/utilities/ptracApi'

export default {
  computed: {
    hasValidationErrors() {
      return this.validationErrors.length > 0
    }
  },
  data() {
    return {
      taskTemplateJson: null,
      validationErrors: [],
      schema: {
        id: '/TaskTemplate',
        type: 'object',
        properties: {
          name: {
            type: ['string', 'null']
          },
          key: {
            type: ['string', 'null']
          },
          departments: {
            type: 'array',
            items: {
              type: ['string', 'null']
            }
          },
          fields: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                label: {
                  type: ['string', 'null']
                },
                key: {
                  type: ['string', 'null']
                },
                placeholder: {
                  type: ['string', 'null']
                },
                syncToCamunda: {
                  type: 'boolean'
                },
                component: {
                  type: ['string', 'null']
                },
                required: {
                  type: 'boolean'
                },
                min: {
                  type: 'number'
                },
                max: {
                  type: 'number'
                },
                expression: {
                  type: ['string', 'null']
                },
                defaultValue: {
                  type: ['string', 'null']
                },
                values: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      label: {
                        type: ['string', 'null']
                      },
                      value: {
                        type: ['string', 'null']
                      },
                      placeholder: {
                        sort: 'number'
                      }
                    }
                  }
                },
                sort: {
                  type: 'number'
                },
                visibleInInspectorApp: {
                  type: 'boolean'
                },
                system: {
                  type: 'boolean'
                },
                active: {
                  type: 'boolean'
                }
              }
            }
          },
          active: {
            type: 'boolean'
          }
        },
        required: [
          'name',
          'key'
        ]
      }
    }
  },
  methods: {
    maybeFilterProperty(propertyName) {
      if (propertyName.indexOf('instance.') === 0) {
        return propertyName.substr(9)
      }
    },
    async validateAndSubmit() {
      this.validationErrors = []

      try {
        // if the JSON cannot be parsed, it will throw an error
        const taskTemplate = JSON.parse(this.taskTemplateJson)
        taskTemplate.ownerId = this.$store.get('security/userId')

        const validationResult = validate(taskTemplate, this.schema)

        if (!validationResult.valid) {
          this.validationErrors = validationResult.errors
          notifyWarning(this, 'Your JSON is syntactically valid but it does not match the Task Template schema')
          return
        }

        const endpoint = 'task-templates/'

        if (taskTemplate.id) {
          const existsResponse = await ptracGet(endpoint + taskTemplate.id)

          if (OK === existsResponse.status) {
            notifyWarning(this, taskTemplate.name + ' exists. Import cancelled.')
            return
          }
        }

        let response = null

        if (taskTemplate.id) {
          response = await ptracPut(endpoint + taskTemplate.id, taskTemplate)
        }  else {
          response = await ptracPost(endpoint, taskTemplate)
        }

        if (CREATED === response.status) {
          notifySuccess(this, taskTemplate.name + ' created successfully')
          this.$emit('close')
          return
        }

        notifyError(this, 'Failed to save task template', response.errors)
      } catch (e) {
        notifyError(this, 'Your JSON is not valid: ' + JSON.stringify(e))
      }
    }
  }
}
</script>
